/**
 * Checa se um valor é truthy.
 * @param {any} val O valor a ser checado.
 * @return {boolean}
 */
export function isTruthy(val) {
  return !!val;
}

const util = {
  isTruthy,
};

export default util;
